export const endPoints = {
    SCHEDULER: {
        GET: '/v3/scheduler/info/get',
        SAVE: '/v3/scheduler/schedulerbooking',
    }
}